var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"56":1,"127":1,"238":1,"305":1,"377":1,"474":1,"569":1,"573":1,"697":1,"706":1,"778":1,"893":1,"1074":1,"1135":1,"1248":1,"1251":1,"1394":1,"1732":1,"1778":1,"2168":1,"2189":1,"2284":1,"2351":1,"2443":1,"2579":1,"2757":1,"2811":1,"2841":1,"3072":1,"3397":1,"3448":1,"3664":1,"3775":1,"3876":1,"3944":1,"4035":1,"4328":1,"4540":1,"4995":1,"5398":1,"5413":1,"5439":1,"5534":1,"5548":1,"5574":1,"5754":1,"5855":1,"5908":1,"5917":1,"5988":1,"6068":1,"6108":1,"6339":1,"6838":1,"6868":1,"6873":1,"6885":1,"6970":1,"7031":1,"7080":1,"7404":1,"7463":1,"7482":1,"7605":1,"7672":1,"7706":1,"7719":1,"7866":1,"7973":1,"7986":1,"8012":1,"8045":1,"8062":1,"8505":1,"8528":1,"8563":1,"8688":1,"8745":1,"8759":1,"8788":1,"8945":1,"8973":1,"9111":1,"9260":1,"9336":1,"9338":1,"9430":1,"9587":1,"9605":1,"9614":1,"9640":1,"9642":1,"9755":1,"9812":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr